class Beneficiary {
  id: string;
  name: string;
  iban: string;
  bankName: string;
  bic: string;
  creditorFullName: string;
  bankCountry: string;
  bankCity: string;
  bankAddress: string;
  debitCurrency: number;
  debitCurrDescription: string;
  ecommbx: boolean;
  beneficiaryCity?: string;
  beneficiaryAddress?: string;
  beneficiaryCountry?: string;

  constructor(
    id: string,
    name: string,
    iban: string,
    bankName: string,
    bic: string,
    creditorFullName: string,
    bankCountry: string,
    bankCity: string,
    bankAddress: string,
    debitCurrency: number,
    debitCurrDescription: string,
    ecommbx: boolean,
    beneficiaryCity?: string,
    beneficiaryAddress?: string,
    beneficiaryCountry?: string,
  ) {
    this.id = id;
    this.name = name;
    this.iban = iban;
    this.bankName = bankName;
    this.bic = bic;
    this.creditorFullName = creditorFullName;
    this.bankCountry = bankCountry;
    this.bankCity = bankCity;
    this.bankAddress = bankAddress;
    this.debitCurrency = debitCurrency;
    this.debitCurrDescription = debitCurrDescription;
    this.ecommbx = ecommbx;
    this.beneficiaryCity = beneficiaryCity ?? '';
    this.beneficiaryAddress = beneficiaryAddress ?? '';
    this.beneficiaryCountry = beneficiaryCountry ?? '';
  }
}

export { Beneficiary };
